<span class="glossary-title" (click)="openDialog($event)">{{title}}</span>